type AnyObject = { [key: string]: any };


export function resolveTemplateWithObject(
  obj: AnyObject,
  expression: string,
  fallback: string = "N/A"
): string {
  return expression.replace(/\$([a-zA-Z0-9_.\[\]]+)/g, (_, key: string) => {
    const keys: string[] = key.split(/[\.\[\]]/).filter(k => k !== "");
    let value: any = obj;

    for (let i = 0; i < keys.length; i++) {
      const k = keys[i];

      // THOUSAND_FORMAT
      if (k === "THOUSAND_FORMAT") {
        if (!isNaN(Number(value))) {
          return (Number(value) / 1_000).toFixed(2) + "K";
        } else {
          return fallback;
        }
      }

      // MILLION_FORMAT
      if (k === "MILLION_FORMAT") {
        if (!isNaN(Number(value))) {
          return (Number(value) / 1_000_000).toFixed(2) + "M";
        } else {
          return fallback;
        }
      }

      // BILLION_FORMAT
      if (k === "BILLION_FORMAT") {
        if (!isNaN(Number(value))) {
          return (Number(value) / 1_000_000_000).toFixed(2) + "B";
        } else {
          return fallback;
        }
      }

      // CURRENCY_FORMAT
      if (k === "CURRENCY_FORMAT") {
        if (!isNaN(Number(value))) {
          return Number(value).toLocaleString("en-US", { minimumFractionDigits: 2 });
        } else {
          return fallback;
        }
      }

      // PERCENTAGE_FORMAT
      if (k === "PERCENTAGE_FORMAT") {
        if (!isNaN(Number(value))) {
          return (Number(value) * 100).toFixed(2) + "%";
        } else {
          return fallback;
        }
      }

      // DECIMAL_FORMAT(n)
      if (k.startsWith("DECIMAL_FORMAT")) {
        if (!isNaN(Number(value))) {
          const decimalPlaces = parseInt(k.match(/\((\d+)\)/)?.[1] || "2", 10);
          return Number(value).toFixed(decimalPlaces);
        } else {
          return fallback;
        }
      }

      // ROUND_FORMAT
      if (k === "ROUND_FORMAT") {
        if (!isNaN(Number(value))) {
          return Math.round(Number(value)).toString();
        } else {
          return fallback;
        }
      }

      // Handle arrays and indexes
      if (Array.isArray(value)) {
        if (k === "COUNT") {
          return value.length.toString();
        }

        const index = parseInt(k);
        if (isNaN(index) || index >= value.length || index < 0) {
          return fallback;
        }
        value = value[index];
      } else {
        value = value[k as keyof typeof value];
      }

      if (value === undefined || value === null) return fallback;
    }

    return value;
  });
}


export enum TemplateResolverFormat {
  THOUSAND_FORMAT = "THOUSAND_FORMAT",
  MILLION_FORMAT = "MILLION_FORMAT",
  BILLION_FORMAT = "BILLION_FORMAT",
  CURRENCY_FORMAT = "CURRENCY_FORMAT",
  PERCENTAGE_FORMAT = "PERCENTAGE_FORMAT",
  ROUND_FORMAT = "ROUND_FORMAT"
}

export enum TemplateResolverArrayUtil {
  COUNT = "COUNT",
}
